import { render, staticRenderFns } from "./all_hzw.vue?vue&type=template&id=2cbcfb9d&scoped=true&"
import script from "./all_hzw.vue?vue&type=script&lang=ts&"
export * from "./all_hzw.vue?vue&type=script&lang=ts&"
import style0 from "./all_hzw.vue?vue&type=style&index=0&id=2cbcfb9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbcfb9d",
  null
  
)

export default component.exports